/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { AdminGetVideoOptions, AdminGetVideoStatus200, AdminGetVideoStatus422 } from '../models/AdminGetVideo'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { adminGetVideo } from '../clients/axios/adminGetVideo'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const adminGetVideoQueryKey = ({ path }: Omit<AdminGetVideoOptions, 'headers'>) => [{ url: '/admin/video/:video_id', params: path }] as const

type AdminGetVideoQueryKey = ReturnType<typeof adminGetVideoQueryKey>

export function adminGetVideoQueryOptions({ path }: AdminGetVideoOptions, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = adminGetVideoQueryKey({ path })
  return queryOptions<AdminGetVideoStatus200, ResponseErrorConfig<AdminGetVideoStatus422>, AdminGetVideoStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await adminGetVideo({ ...config, path, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @summary Get Video
 * {@link /admin/video/:video_id}
 */
export function useAdminGetVideo<TData = AdminGetVideoStatus200, TQueryData = AdminGetVideoStatus200, TQueryKey extends QueryKey = AdminGetVideoQueryKey>({ path }: { path: AdminGetVideoOptions['path'] | (() => AdminGetVideoOptions['path']) }, options: {
  query?: Partial<QueryObserverOptions<AdminGetVideoStatus200, ResponseErrorConfig<AdminGetVideoStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? adminGetVideoQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...adminGetVideoQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AdminGetVideoStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
